"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROARR = void 0;
const globalthis_1 = __importDefault(require("globalthis"));
const factories_1 = require("./factories");
const globalThis = globalthis_1.default();
const ROARR = globalThis.ROARR = factories_1.createRoarrInitialGlobalState(globalThis.ROARR || {});
exports.ROARR = ROARR;
const logFactory = factories_1.createLogger;
exports.default = logFactory((message) => {
    if (ROARR.write) {
        // Stringify message as soon as it is received to prevent
        // properties of the context from being modified by reference.
        const body = JSON.stringify(message);
        ROARR.write(body);
    }
});
